/** Append geoclient workspace id when navigating inside a geoclient workspace. */
export function withGeoclientQuery(path: string, geoclientId?: string | null): string {
  if (!geoclientId?.trim()) return path;
  const sep = path.includes('?') ? '&' : '?';
  return `${path}${sep}geoclientId=${encodeURIComponent(geoclientId)}`;
}

export function parseGeoclientId(raw: string | null | undefined): string | undefined {
  const trimmed = raw?.trim();
  if (!trimmed) return undefined;
  return trimmed;
}

/** Query suffix for API mutation URLs (`?geoclientId=` or ``). */
export function geoclientQuery(geoclientId?: string | null): string {
  if (!geoclientId?.trim()) return '';
  return `?geoclientId=${encodeURIComponent(geoclientId)}`;
}
